import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSearch } = FiIcons;

const SearchBar = ({ searchQuery, setSearchQuery }) => {
  return (
    <div className="max-w-2xl mx-auto mb-16 px-6">
      <div className="relative group">
        <div className="absolute inset-y-0 left-0 pl-5 flex items-center pointer-events-none">
          <SafeIcon icon={FiSearch} className="w-5 h-5 text-[#A67C52] transition-colors group-focus-within:text-[#6E7451]" />
        </div>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search resources, strategy pages, or tools..."
          className="w-full bg-white border border-[#D9CCBA]/60 rounded-2xl py-5 pl-14 pr-6 text-[#2F2B28] placeholder:text-[#2F2B28]/30 focus:outline-none focus:ring-4 focus:ring-[#D9CCBA]/20 focus:border-[#D9CCBA] transition-all duration-300 shadow-sm"
        />
        {searchQuery && (
          <button 
            onClick={() => setSearchQuery('')}
            className="absolute inset-y-0 right-0 pr-5 flex items-center text-[#2F2B28]/40 hover:text-[#2F2B28]"
          >
            <span className="text-xs uppercase tracking-widest">Clear</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;